import * as React from 'react'
import * as ReactDOM from 'react-dom'
import RemarksApplicationRoot from '@components/RemarksApplicationRoot'
// import { getUid, setSession, setUid } from './api'
import { ThemeProvider } from 'styled-components'
import Theme from './Theme'

import './index.css'
import 'draft-js/dist/Draft.css'

type State = {
  [key: string]: any
}

// const uid = getUidFromUri()
// if (uid) setUid(uid)

// function getUidFromUri() {
//   const lastWord = window.location.pathname.split('/').pop()
//   return lastWord && lastWord.length === 8 ? lastWord : undefined
// }

// const session = localStorage.getItem('minutes_session')
// let state: State

// if (session) {
//   setSession(session)
//   getUid().then(response => {
//     const { tasks, title } = response.data
//     state = { ...state, tasks, title }
//   })
// } else {
// }
mount()

function mount(initState?: State) {
  console.log('call mount')
  ReactDOM.render(
    <ThemeProvider theme={Theme}>
      <RemarksApplicationRoot />
    </ThemeProvider>,
    document.getElementById('minutes')
  )
}



// WEBPACK FOOTER //
// ./src/index.tsx